<mat-dialog-content>
  <div class="alert-dialog-wrapper">
    <div class="alert-dialog-icon">
      <mat-icon class="red-icon">warning</mat-icon>
    </div>
    <div class="alert-dialog-message-text">
      {{ data.message }}
    </div>
    <div>
      <button
        mat-raised-button
        (click)="onConfirmClick()"
        color="basic"
        mat-dialog-close
        tabindex="-1">
        Acknowledge
        <mat-icon class="green-icon">check</mat-icon>
      </button>
    </div>
  </div>
</mat-dialog-content>
